module.exports = __webpack_public_path__ + "img/arrow-down.d2c590b6.svg";